module.exports = __webpack_public_path__ + "static/img/pptImg2.84b4ad9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/pptImg2.png
// module id = OTbm
// module chunks = 3